// src/components/editor/SidebarPanelHeader.jsx
//
// Heading strip at the top of an open sidebar panel, carrying the panel's name
// and the way back to the icon strip.
//
// This exists because opening a panel now REPLACES the strip rather than
// sitting beside it, so the strip is no longer on screen to navigate with. The
// back arrow is the only route out, which is why it leads rather than trails.
//
// The arrow is an IconButton, not a Button, on purpose: .sidebar-panel-vertical
// ships global CSS that repaints any MuiButton inside it as a full-width gold
// pill.
import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export default function SidebarPanelHeader({ title, onBack }) {
  return (
    <Box className="sidebar-panel-header">
      <Tooltip title="Back to all tools">
        <IconButton
          size="small"
          className="sph-back"
          onClick={onBack}
          aria-label="Back to all tools"
        >
          <ArrowBackIcon sx={{ fontSize: 17 }} />
        </IconButton>
      </Tooltip>
      <span className="sph-title">{title}</span>
    </Box>
  );
}
